/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import MuiMenu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Magnetic as Mi } from "../../styles";
import { Utilities } from '../../utilities';
const DroplistItem = (isIconAvailable) => css `
	height: ${Mi.buttonBaseMinHeight};
	color: ${Mi.colorMocha08};
	font-size: ${Mi.fontSize14};
	padding: ${isIconAvailable ? `2px ${Mi.spacer16} 2px ${Mi.spacer08}` : ''};
	&:hover {
		background-color: ${Mi.colorUltrablue01};
		cursor: pointer;
	}
`;
const DroplistIconStyle = css `
	width: 3rem;
	text-align: center;
	color: ${Mi.colorBrand05};
`;
export const MenuItems = (props) => {
    const mapMenuItem = (items, insertDivider) => {
        return items.map((item, index, arr) => (jsx(MenuItem, { key: Utilities.generateHashCodeFromObject(item), css: item.style ? item.style : DroplistItem(props.isIconAvailable), onClick: event => {
                item.onClick && item.onClick(event);
                props.handleMenuClose(event);
            }, id: `mi-menu-option-${item.id}`, disabled: item.disabled, divider: insertDivider && arr.length - 1 === index },
            props.isIconAvailable && (jsx("span", { id: `mi-menu-option-icon-${item.id}`, css: DroplistIconStyle, "data-testid": `mi-menu-option-icon-${item.id}` }, typeof item.icon === 'string' ? jsx("span", { className: item.icon }) : item.icon)),
            item.label ? jsx("span", null, item.label) : item.children)));
    };
    // If props.items 2d array, build menu with dividers. 2d array check via https://stackoverflow.com/a/55416949
    // Else build menu without dividers
    const localItems = props.items;
    let menuItems = localItems.every(item => Array.isArray(item))
        ? props.items.map((items) => mapMenuItem(items, true))
        : mapMenuItem(props.items, false);
    return (jsx(MuiMenu, { id: "mi-menu", anchorEl: props.anchorEl, anchorOrigin: props.anchorOrigin, transformOrigin: props.transformOrigin, getContentAnchorEl: null, transitionDuration: 0, open: Boolean(props.anchorEl), onClose: props.handleMenuClose, MenuListProps: {
            style: {
                padding: '0px' // removes padding from top and bottom of menu
            }
        } }, menuItems));
};
//# sourceMappingURL=MenuItems.js.map